import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import Root from "./reducers/Root";

ReactDOM.render(
	<Router basename={"/v2"}>
		<AuthProvider>
			<Root>
				<App />
			</Root>
		</AuthProvider>
	</Router>,
	document.getElementById("root")
);
